import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

// Renamed component to be generic
export const ProductCard = ({ image, title, description, description1 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    // Updated class names to match the new CSS
    <div className={`product-card ${isExpanded ? "expanded" : ""}`}>
      <div className="product-card-header" onClick={toggleExpand}>
        <div className="product-card-icon-container">
          <img src={image} alt={title} className="product-card-icon" />
        </div>
        <h3 className="product-card-title">{title}</h3>
        <button className="product-expand-btn" aria-label={isExpanded ? "Collapse" : "Expand"}>
          {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
        </button>
      </div>
      
      <div className="product-card-body2">
        <p className="product-card-description">{description}</p>
        {description1 && (
          <div className={`product-card-details ${isExpanded ? "show" : ""}`}>
            <p>{description1}</p>
          </div>
        )}
      </div>
      {!isExpanded && description1 && (
        <div className="product-read-more" onClick={toggleExpand}>
            Read More
        </div>
      )}
    </div>
  );
};